import type { User } from '@/types/user.type'

export const partnerIdOf = (
  user?: { partner?: { _id?: string } | string | null } | null
) => {
  const partner = user?.partner
  if (!partner) return null
  if (typeof partner === 'string') return partner
  return partner._id || null
}

export const isFullAdmin = (user?: Partial<User> | null) =>
  typeof user?.role === 'number' && user.role < 2

/** Half admin: a regular user assigned to one partner */
export const isPartnerAdmin = (user?: Partial<User> | null) => {
  if (!user || isFullAdmin(user)) return false
  return user.partnerAdmin === true && Boolean(partnerIdOf(user))
}

export const isSubAdmin = isPartnerAdmin

export const hasAdminAccess = (user?: Partial<User> | null) =>
  isFullAdmin(user) || isPartnerAdmin(user)

export const samePartner = (
  actor?: { partner?: { _id?: string } | string | null } | null,
  target?: { partner?: { _id?: string } | string | null } | null
) => {
  const actorPartner = partnerIdOf(actor)
  const targetPartner = partnerIdOf(target)
  return Boolean(
    actorPartner && targetPartner && actorPartner === targetPartner
  )
}
